import { AbstractControl, ValidatorFn } from "@angular/forms";

export function CNPValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const regex = /\b[1-8]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{6}\b/;
        // Second one has additional county code validation
        // const regex = /\b[1-8]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|80|99)\d{4}\b/;

        if (value && !regex.test(value)) {
            return { invalidCNP: true };
        }

        return null;
    };
}